const commonIndexedDBJs = {}
var db = null
commonIndexedDBJs.indexedDB = indexedDB.open('irbgAnalysisDB', 1)
commonIndexedDBJs.indexedDB.onupgradeneeded = function (event) {
  db = event.target.result
  // setStorage('db', db)
  try {
    // db.createObjectStore('store' , { keyPath: 'id' })
     // 新建数据库时-新建对象仓库（新建表）表名 'persionTable'
  var objStore;
  if (!db.objectStoreNames.contains('store')) {
    // 创建新的存储对象  表名 { 主键, 是否自增(默认 false ) } 
    objStore = db.createObjectStore('store', { ketPath: 'id', autoIncrement: true });

  }
  } catch (e) {
    console.log('irbgAnalysis basicProgramData already exists')
  }
}
commonIndexedDBJs.indexedDB.onerror = function () {
  console.log('irbgAnalysis onerror')
}
commonIndexedDBJs.indexedDB.onsuccess = function (e) {
  db = e.target.result
  console.log('irbgAnalysis onsuccess')
}

// IndexedDB取得処理
commonIndexedDBJs.dataGet = function (storeName, cbSuccess, cbError) {
  try {
    let list = [];
    let key
    var trans = db.transaction(storeName, 'readwrite')
    var store = trans.objectStore(storeName)
    var request = store.openCursor(); 
    request.onsuccess = function (e) {
      var cursor = e.target.result;
      if (cursor) {
        cursor.value.key = cursor.key
        list.push(cursor.value);
        cursor.continue();
      } else {
        console.log("list：", list);
        cbSuccess(list)
      }
    };
    // var getReq = store.get(key)
    // getReq.onsuccess = function (event) {
    //   if (cbSuccess !== undefined) cbSuccess(event.target.result)
    // }
    // getReq.onerror = function () {
    //   if (cbError !== undefined) cbError()
    // }
  } catch (e) {
    // console.log('#V2# DB chk 4 error' + storeName)
    if (cbError !== undefined) cbError()
  }
}
// IndexedDB挿入・更新処理
commonIndexedDBJs.dataPut = function (storeName, data, cbSuccess, cbError) {
  try {
    var trans = db.transaction(storeName, 'readwrite')
    var store = trans.objectStore(storeName)
    var putReq = store.put( data )
    putReq.onsuccess = function () {
      if (cbSuccess !== undefined) cbSuccess()
    }
    putReq.onerror = function () {
      if (cbError !== undefined) cbError()
    }
  } catch (e) {
    console.log('put erroe')
    if (cbError !== undefined) cbError()
  }
}

commonIndexedDBJs.dataDelete = function (storeName, key, cbSuccess, cbError) {
  try {
    var trans = db.transaction(storeName, 'readwrite')
    var store = trans.objectStore(storeName)
    var deleteReq = store.delete(key)
    deleteReq.onsuccess = function (event) {
      if (cbSuccess !== undefined) cbSuccess(event.target.result)
    }
    deleteReq.onerror = function () {
      if (cbError !== undefined) cbError()
    }
  } catch (e) {
    if (cbError !== undefined) cbError()
  }
}

export default commonIndexedDBJs



// WEBPACK FOOTER //
// ./src/common/commonIndexedDB.js